/**
 * @desc 统一处理Json Web Token,请求头 Authorization
 */
import { LOCALSTORAGE_JWT_KEY, SITES_DATA, UTC_MAP, LOCALSTORAGE_LANG_KEY, DEFAULT_LANG } from '@ecoflow/ef-device-core/src/constants';
import type { AuthContextType } from '@ecoflow/ef-device-core/src/context/AuthProviderContext';
import { localStoreData } from '@ecoflow/ef-device-core/src/utils';
import { localeUTC, localTimezone } from '@ecoflow/ef-device-core/src/lib/dayjs';
import { getCurrentLang } from '@ecoflow/ef-device-core/src/lib/i18n';

type JWTHandleResType = {
    Authorization?: string;
    'Accept-Language'?: string;
    'x-appid'?: string;
    systemName?: string;
    'Timezone-Code'?: string;
    'Product-Type'?: AuthContextType['productType'];
    timezone?: string;
};

export default function headerHandle(): JWTHandleResType {
    const header: JWTHandleResType = {
        'Timezone-Code': localTimezone,
        timezone: UTC_MAP[localeUTC],
    };

    const [JWT] = localStoreData<string>(LOCALSTORAGE_JWT_KEY);
    if (JWT) header.Authorization = JWT;

    const [localLang] = localStoreData<string>(LOCALSTORAGE_LANG_KEY);
    const lang = getCurrentLang(3) || localLang || DEFAULT_LANG;

    const item = SITES_DATA.find((item) => item.lang === lang);
    if (item) {
        const [locale, language] = item.locale.split('_');
        // en-US,en;q=0.9
        header['Accept-Language'] = `${locale}-${language},${locale};q=0.9`;
    }

    header['x-appid'] = '778';

    header.systemName = 'provider_consumer';

    return header;
}
